import React from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';
import { usePopupContext } from '../contexts/PopupContext';
import { DASHBOARD_PARAMETERS } from '../../constants/dashboard';
import { useAppContext } from '../contexts/AppContext';
import { PERIOD_LABEL } from '../../constants/enrollment';
import { useTRCAppContext } from '../contexts/TRCAppContext';
import { getPreviousPeriod } from './utils';

const DeletePresumedResultPopup = () => {
    const trcApp = useTRCAppContext();
    const {
        actions: { hideDeletePresumedResultPopup },
        params,
    } = usePopupContext();

    const {
        applicationSpecificCallbacks: {
            [trcApp]: {
                [DASHBOARD_PARAMETERS.DELETE_PRESUMED_RESULT_CALLBACK]: deletePresumedResult,
            },
        },
        reloadPage,
    } = useAppContext();

    const onDeletePresumedResultClick = _e => {
        deletePresumedResult(
            params.presumedResultDetails.classId,
            params.presumedResultDetails.studentId,
            params.presumedResultDetails.period,
            params.presumedResultDetails.grade,
            params.presumedResultDetails.application,
        );
        hideDeletePresumedResultPopup();
        reloadPage();
    };

    return (
        <Popup
            cssClass="delete-presumed-result-popup"
            header="Delete Reported Level"
            message={
                <span>
                    Do you want to remove the proficiency level reported from the{' '}
                    {PERIOD_LABEL[getPreviousPeriod(params.presumedResultDetails.period)]} screening{' '}
                    and assess {params.presumedResultDetails.studentName} for{' '}
                    {PERIOD_LABEL[params.presumedResultDetails.period]}? Deleting the reported level
                    cannot be undone.
                </span>
            }
            buttons={[
                <Button
                    key="delete-presumed-result-button"
                    cssClasses="delete-presumed-result-button"
                    onClick={onDeletePresumedResultClick}
                >
                    Yes
                </Button>,
                <Button
                    key="cancel-delete-presumed-result-button"
                    cssClasses="cancel-delete-presumed-result-button"
                    onClick={hideDeletePresumedResultPopup}
                >
                    No
                </Button>,
            ]}
        />
    );
};

export default DeletePresumedResultPopup;
